export default (function (vm) {
  return [{
    type: 'selection',
    width: 60,
    align: 'center'
  }, {
    title: '品种id',
    key: 'cbid',
    width: 100
  }, {
    title: '品种图片',
    slot: 'cover',
    width: 100,
    align: 'center'
  }, {
    title: '品种名称',
    key: 'description',
    minWidth: 200,
    search: true
  }, {
    title: '状态',
    slot: 'status',
    width: 100
  }, {
    title: '操作',
    slot: 'action',
    width: 150,
    align: 'center'
  }];
});